import {
  KeyboardArrowDown,
  Edit,
  CheckCircle,
  CheckCircleOutline,
} from "@material-ui/icons";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import noRecord from "./../../assets/img/no-record.png";
import {
  getAiPromptsListAction,
  getAiCategoriesAction,
  updateAiPromptStatusAction,
} from "../../actions/AiActions";
import ReactPaginate from "react-paginate";
import * as code from "../../config/Constants";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
class AiPromptsListing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "AI Prompts",
      aiPromptsList: [],
      categoryId: "",
      order: "desc",
      PageSize: code.RECORD_PER_PAGE,
      page: 0,
      pageCount: 0,
      aiCategoryList: [],
    };
  }
  columns = [
    {
      name: "Category",
      selector: "category",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Subcategory",
      selector: "subCategory",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Template",
      selector: "promptTemplate",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Description",
      selector: "description",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Status",
      selector: "Status",
      sortable: false,
      width: "115px",
    },
    {
      name: "Default",
      selector: "Default",
      sortable: false,
      width: "115px",
    },
    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "10%",
    },
  ];
  componentWillMount() {
    this.getAllAIPrompts();
    this.props.getAiCategoriesAction().then((res) => {
      this.setState({ aiCategoryList: res.data.data });
    });
  }
  getAllAIPrompts() {
    this.setState({
      showLoader: true,
    });
    this.props
      .getAiPromptsListAction(
        this.state.PageSize,
        this.state.page,
        this.state.categoryId,
        this.state.order
      )
      .then((res) => {
        this.setState({
          aiPromptsList: res.data.data || [],
          pageCount: res.data.total,
          showLoader: false,
        });
      });
  }

  changePage = async (event) => {
    this.setState({ page: event.selected }, () => {
      this.getAllAIPrompts();
    });
  };

  handleChange = (event) => {
    this.setState({ PageSize: event.target.value, page: 0 }, () => {
      this.getAllAIPrompts();
    });
  };

  changeStatus = (aiprompt, flag) => {
    let data = {
      categoryId: aiprompt.categoryId,
      subCategoryId: aiprompt.subCategoryId,
      id: aiprompt._id,
      type: flag,
    };
    this.props
      .updateAiPromptStatusAction(data)
      .then((res) => {
        if (res.status === code.OK) {
          this.getAllAIPrompts();
        } else {
          this.getAllAIPrompts();
        }
      })
      .catch((err) => {});
  };

  checkDefault(aiPrompt) {
    if (aiPrompt.isDefault) {
      if (aiPrompt.isActive) {
        //show popup that you cannot upate it.
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="">
                <div className="react-confirm-alert-body">
                  <h2>Active / Deactive</h2>
                  <p>
                    You cannot make this prompt status deactive because it is
                    default. If you want to deactivate this, please change
                    default.
                  </p>
                  <div className="react-confirm-alert-button-group">
                    <button onClick={onClose}>Close</button>
                  </div>
                </div>
              </div>
            );
          },
        });
      } else {
        this.changeStatus(aiPrompt, "Status");
      }
    } else {
      this.changeStatus(aiPrompt, "Status");
    }
  }

  checkStatus(aiPrompt) {
    if (!aiPrompt.isActive) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="">
              <div className="react-confirm-alert-body">
                <h2>Active / Deactive</h2>
                <p>
                  You cannot change default status because it is currently
                  inactive.
                </p>
                <div className="react-confirm-alert-button-group">
                  <button onClick={onClose}>Close</button>
                </div>
              </div>
            </div>
          );
        },
      });
    } else {
      this.changeStatus(aiPrompt, "Default");
    }
  }

  render() {
    let rows = [];
    for (var i = 0, len = this.state.aiPromptsList.length; i < len; i++) {
      let aiPrompt = this.state.aiPromptsList[i];
      let data = {
        category: aiPrompt.category,

        subCategory: aiPrompt.subCategory,
        promptTemplate: aiPrompt.promptTemplate
          ? aiPrompt.promptTemplate.length > 60
            ? aiPrompt.promptTemplate.slice(0, 60) + "..."
            : aiPrompt.promptTemplate
          : "",

        description: aiPrompt.description
          ? aiPrompt.description.length > 60
            ? aiPrompt.description.slice(0, 60) + "..."
            : aiPrompt.description
          : "",

        Status: aiPrompt.isActive ? (
          <CheckCircle
            className="check"
            style={{ color: "green" }}
            onClick={() => this.checkDefault(aiPrompt)}
          />
        ) : (
          <CheckCircleOutline
            className="check-out"
            onClick={() => this.checkDefault(aiPrompt)}
          />
        ),
        Default: aiPrompt.isDefault ? (
          <CheckCircle
            className="check"
            style={{ color: "green" }}
            onClick={() => this.checkStatus(aiPrompt)}
          />
        ) : (
          <CheckCircleOutline
            className="check-out"
            onClick={() => this.checkStatus(aiPrompt)}
          />
        ),

        action: (
          <div className="action-btns">
            <Button
              variant="transparent"
              onClick={() => {
                this.props.history.push({
                  pathname: "/AiPrompt",
                  state: {
                    id: aiPrompt._id,
                  },
                });
              }}
            >
              <Edit />
            </Button>
          </div>
        ),
      };

      rows.push(data);
    }
    return (
      <div>
        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center mt-10">
          <Col xs="4">
            <h4 className="title-med mt-0 pt-1">{this.state.title}</h4>
          </Col>
          <Col align="right" className="contact-btn">
            <FormControl
              sx={{ m: 0, minWidth: 120 }}
              size="small"
              className="mr-3"
            >
              <div className="c-select">
                <select
                  className="form-control form-control-sm form-control-head"
                  value={this.state.categoryId}
                  onChange={(e) => {
                    this.setState(
                      {
                        categoryId: e.target.value,
                      },
                      () => {
                        this.getAllAIPrompts();
                      }
                    );
                  }}
                >
                  <option value="">Select Category</option>
                  {this.state.aiCategoryList.map((cat) => {
                    return (
                      <>
                        <option value={cat._id}>{cat.name}</option>
                      </>
                    );
                  })}
                </select>
              </div>
            </FormControl>
            <FormControl
              sx={{ m: 0, minWidth: 120 }}
              size="small"
              className="mr-3"
            >
              <div className="c-select">
                <select
                  className="form-control form-control-sm form-control-head"
                  value={this.state.order}
                  onChange={(e) => {
                    this.setState(
                      {
                        order: e.target.value,
                      },
                      () => {
                        this.getAllAIPrompts();
                      }
                    );
                  }}
                >
                  <option value="asc">Asc</option>
                  <option value="desc">Desc</option>
                </select>
              </div>
            </FormControl>
            <FormControl
              sx={{ m: 0, minWidth: 120 }}
              size="small"
              className="mr-3"
            >
              <InputLabel id="demo-select-small">Limit</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={this.state.PageSize}
                label="Page"
                onChange={this.handleChange}
                style={{ backgroundColor: "hsl(0,0%,100%)" }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
            <Button
              variant="primary"
              className="btn-blue btn-head"
              onClick={() => {
                this.props.history.push({
                  pathname: "/AiPrompt",
                });
              }}
            >
              Add AI Prompt
            </Button>
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Data Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              onRowSelected={this.getSelectedRows}
            />

            {rows.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={this.state.pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={this.changePage}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                  forcePage={this.state.page}
                />
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    getAiPromptsListAction,
    getAiCategoriesAction,
    updateAiPromptStatusAction,
  }
)(AiPromptsListing);
